import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { getFromS3 } from '../../lib/s3'
import type { Note } from './noteSchemas'

export const getNoteById = createServerFn({ method: 'GET' })
  .inputValidator(z.object({ noteId: z.string().min(1) }))
  .handler(async (ctx): Promise<Note> => {
    return await getFromS3(`notes/${ctx.data.noteId}.json`)
  })
